export class FiscalDateDays {
  private static msInOneDay = 24 * 60 * 60 * 1000;

  /**
   * Simple dateString parsing into fiscalDateDays.
   * @param dateString The date string to be parsed.
   * @param format The format of the date string. Only formats with "yyyy" for the year, "MM" for the month, and "dd" for the day, and non-digit characters for the separator are supported.
   * @returns FiscalDateDays as number
   */
  static parseDate(dateString: string, format: string): number {
    const parts = dateString.split(/[^\d]+/);
    const formatParts = format.split(/[^\w]+/);

    const year = parseInt(parts[formatParts.indexOf("yyyy")], 10);
    const month = parseInt(parts[formatParts.indexOf("MM")], 10) - 1;
    const day = parseInt(parts[formatParts.indexOf("dd")], 10);

    return Date.UTC(year, month, day) / this.msInOneDay;
  }
}
